<template>
  <div style="padding: 0 6% 0 2%">
    <h2>注销账号</h2>
    <div style="min-height: 224px">
      <h3>账号注销后，为您提供的一切服务将不再生效</h3>
      <el-form
        ref="ruleFormRef"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
        :size="formSize"
        status-icon
      >
        <el-form-item label="确认密码" prop="password">
          <el-input
            v-model="ruleForm.password"
            size="large"
            type="password"
            show-password
            placeholder="请输入密码"
          />
        </el-form-item>
        <el-form-item label-width="0">
          <el-button
            type="primary"
            style="width: 70%; margin-left: 20%;margin-top: 50px;"
            background-color="#E65833"
            @click="submitForm(ruleFormRef)"
          >
            确认注销
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from "vue";
import {loginOff} from "@/request/api/login";
import {ElMessage} from "element-plus";
import useLogin from "@/stores/login";
const formSize = ref("default");
const ruleFormRef = ref();
const ruleForm = reactive({
  password: "",
});
const rules = reactive({
  password: [{ required: true, message: "请输入密码", trigger: "blur" }],
});

const loginStore = useLogin();

const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      loginOff(ruleForm).then(res=>{
        if(res.status == 10000){
          ElMessage.success("注销成功");
          loginStore.userInfo = null;
          loginStore.token = "";
          loginStore.code = "";
          loginStore.agencyId = undefined;
          loginStore.userId = undefined;
          loginStore.roleId = -1;
          loginStore.username = undefined;
          loginStore.headImg = "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
        }else {
          ElMessage.error(res.msg);
        }
      })


      console.log("submit!");
    } else {
      console.log("error submit!", fields);
    }
  });
};
</script>

<style lang="scss" scoped>
@import "@/styles/elementButton.scss";
@import "@/styles/common.scss";
@import "@/styles/variables.scss";
h2 {
  margin: 0 0 30px 0;
  text-align: center;
  color: #000;
}
h3{
  margin: 0 0 50px 0;
  text-align: center;
  color: #000;
}
</style>
